import Thor from '@qconcursos/thor';

window.Thor = Thor;
window.Thor.setup({usejQ: true});
